import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router";

import { useAppDispatch } from "store/hooks";
import { clearSession } from "store/features/authSlice";

import authService from "services/auth";

import { routes } from "./routes";

const ProtectedRoute = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const accessToken = authService().getAccessToken();
  const refreshToken = authService().getRefreshToken();

  const isAuthenticated = !!accessToken && !!refreshToken;

  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(clearSession(null));
    }
  }, [isAuthenticated]);

  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate replace to={routes.auth} state={{ from: location.pathname }} />
  );
};

export default ProtectedRoute;
